module.exports = __webpack_public_path__ + "img/small-4.8315c534.jpg";